import * as TableOperations from './actions/tableOperations';
// Export TableOperations API
export default TableOperations;
//# sourceMappingURL=index.js.map